import React, { Component } from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import { connect } from 'react-redux';

@connect((store) => {
    return { site: store.siteMaster, account: store.accountMaster }
})
class SendOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

    }

    componentDidMount() {

    }


    render() {

        return (
            <>
                <div className="mar-b25">
                    <h3 className="mar-b15">Send and Track</h3>
                    <p >Create, send and track email campaigns, use site tracking to view website visitors and interact with them, send transactional emails, and more...</p>
                </div>

                <Row>
                    <Column xs={12} sm={6}>
                        <Paper>
                            <h3 className="mar-b10">Campaigns</h3>
                            <p>Design and send email campaigns, and AB Split Tests</p>
                            <Button text="Click Here" onClick={() => { this.props.history.push("/cp/campaigns") }} />
                        </Paper>
                    </Column>

                    <Column xs={12} sm={6}>
                        <Paper>
                            <h3 className="mar-b10">Website Tracking</h3>
                            <p>Track visitors around your website, interact via instant chat.</p>
                            <Button text="Click Here" onClick={() => { this.props.history.push("/cp/trackers") }} />
                        </Paper>
                    </Column>
                    <Column xs={12} sm={6}>
                        <Paper>
                            <h3 className="mar-b10">Transactional Emails</h3>
                            <p>Send one off emails to your customers</p>
                            <Button text="Click Here" onClick={() => { this.props.history.push("/cp/transactions") }} />
                        </Paper>
                    </Column>
                </Row>
            </>
        );
    }
}

export default SendOverview;